import {playSplitText,} from '../common/help_functions';


export function initTitleSection(element) {
    playSplitText('.simple-title-section .title', true)
}